import { useState } from "react";
import Header from "./Header"
import ModuleCard from "./ModuleCard"

const Gallery = (props) => {
    const [filter, setFilter] = useState("");
    const { modules } = props;

    return(          
        <div className="mainContent" style={{width:"100%", backgroundColor: "#f8f8f8"}}>
            <Header setFilter={setFilter}/>
            <div className="gameListing" role="main">
            {modules ? 
                modules.map(
                    (module, idx) => 
                        module.id.includes(filter) && module.visible === true 
                            ? <ModuleCard key={idx} idx={idx} module={module}/> 
                            : null
                )
                :
                <h5>Loading...</h5>
            }
            </div>
        </div>)
}

export default Gallery;